/**
 * cross-sell.js
 * Adiciona produtos do cross sell ao carrinho via AJAX
 * e atualiza o drawer usando o sistema de eventos nativo do Vessel.
 *
 * Vessel 2.0 — Maré Chocolate
 */

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.mare-cs-card__btn');
  if (!btn || btn.disabled) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  btn.textContent = 'Adicionando...';

  try {
    // 1️⃣ Pega o sectionId do cart-items-component para passar ao Vessel
    const sectionId = document
      .querySelector('cart-items-component')
      ?.dataset.sectionId;

    // 2️⃣ Monta o body — pede a seção junto para o Vessel atualizar o drawer
    const body = {
      items: [{ id: Number(variantId), quantity: 1 }],
    };
    if (sectionId) {
      body.sections = sectionId;
      body.sections_url = window.location.pathname;
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    if (!res.ok) throw new Error('Erro ao adicionar');

    const cartData = await res.json();

    // 3️⃣ Dispara o evento nativo do Vessel (cart:update)
    // CartAddEvent.eventName === ThemeEvents.cartUpdate === 'cart:update'
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cartData,
          sourceId: 'cross-sell',
          data: {
            source: 'cross-sell',
            variantId: String(variantId),
            itemCount: cartData.item_count,
            sections: cartData.sections ?? null,
          },
        },
      })
    );

    // 4️⃣ Se o Vessel devolveu o HTML da seção, atualiza o drawer manualmente
    if (sectionId && cartData.sections?.[sectionId]) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartData.sections[sectionId], 'text/html');
      const novo = doc.querySelector('cart-items-component');
      const atual = document.querySelector('cart-items-component');
      if (novo && atual) atual.innerHTML = novo.innerHTML;
    }

    // 5️⃣ Atualiza o botão
    btn.textContent = '✓ Adicionado';
    btn.classList.add('adicionado');

  } catch (err) {
    console.error('[cross-sell]', err);
    btn.textContent = 'Erro — tente novamente';
    btn.disabled = false;
  }
});
// ── Arrows navigation ──
function mareInitArrows() {
  const grid = document.getElementById('mare-cs-grid');
  const prev = document.getElementById('mare-cs-prev');
  const next = document.getElementById('mare-cs-next');
  if (!grid || !prev || !next) return;

  const cardWidth = () => {
    const card = grid.querySelector('.mare-cs-card');
    if (!card) return 126;
    return card.offsetWidth + 8; // card + gap
  };

  const updateButtons = () => {
    prev.disabled = grid.scrollLeft <= 0;
    next.disabled = grid.scrollLeft + grid.offsetWidth >= grid.scrollWidth - 2;
  };

  prev.addEventListener('click', () => {
    grid.scrollBy({ left: -cardWidth() * 2, behavior: 'smooth' });
  });

  next.addEventListener('click', () => {
    grid.scrollBy({ left: cardWidth() * 2, behavior: 'smooth' });
  });

  grid.addEventListener('scroll', updateButtons, { passive: true });
  updateButtons();
}

// Inicializa em todos os eventos relevantes do drawer
document.addEventListener('cart:update',  () => setTimeout(mareInitArrows, 300));
document.addEventListener('cart:refresh', () => setTimeout(mareInitArrows, 600));
document.addEventListener('DOMContentLoaded', () => setTimeout(mareInitArrows, 500));

// Re-inicializa quando o drawer abre (clique no ícone do carrinho)
document.addEventListener('click', (e) => {
  if (e.target.closest('cart-drawer-component button[on\\:click]')) {
    setTimeout(mareInitArrows, 400);
  }
});